import {GET_DATA_REQUEST, GET_DATA_PERCENTAGE_CHANGE, GET_CRYPTO_PRICE, GET_CRYPTO_PREDICTION,  GET_DATA_SUCCESS, GET_DATA_ERROR} from '../actions/ProfileAction'; // Import our actions
const initialState = {
  value: {},
  price_btc: {}, 
  price_eth: {}, 
  price_ltc: {}, 
  price_xrp: {}, 
  price_eos: {}, 
  price_bnb: {},  
  price_doge: {}, 
  price_ada: {}, 
  price_link: {},  
  prediction_btc: {}, 
  prediction_eth: {}, 
  prediction_ltc: {}, 
  prediction_eos: {}, 
  prediction_xrp: {}, 
  prediction_bnb: {}, 
  prediction_doge: {}, 
  prediction_ada: {}, 
  prediction_link: {}, 
  percentage_change: {}, 
  prediction_btc_1d: {}, 
  prediction_eth_1d: {}, 
  prediction_xrp_1d: {}, 
  prediction_ltc_1d: {}, 
  prediction_eos_1d: {}, 
  prediction_bnb_1d: {},
  prediction_ada_1d: {}, 
  prediction_doge_1d: {}, 
  prediction_link_1d: {},
  isFetching:true,
  isFetchingPrediction: true, // Default to fetching..
  isFetchingPrice: true, // Default to fetching..
  isFetchingPercentage: true, // Default to fetching..

  error: null
};


const ProfileReducer = function (state = initialState, action){
  switch (action.type) {
    case GET_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        value: action.value,
        price_btc: action.price_btc, 
        price_eth: action.price_eth, 
        price_ltc: action.price_ltc, 
        price_xrp: action.price_xrp, 
        price_eos: action.price_eos, 
        price_bnb: action.price_bnb, 

        price_doge: action.price_doge, 
        price_ada: action.price_ada, 
        price_link: action.price_link, 

        prediction_btc: action.prediction_btc, 
        prediction_eth: action.prediction_eth, 
        prediction_ltc: action.prediction_ltc, 
        prediction_eos: action.prediction_eos, 
        prediction_xrp: action.prediction_xrp, 
        prediction_bnb: action.prediction_bnb, 

        prediction_doge: action.prediction_doge, 
        prediction_ada: action.prediction_ada, 
        prediction_link: action.prediction_link, 

        percentage_change: action.percentage_change, 
        prediction_btc_1d: action.prediction_btc_1d, 
        prediction_eth_1d: action.prediction_eth_1d, 
        prediction_xrp_1d: action.prediction_xrp_1d, 
        prediction_ltc_1d:  action.prediction_ltc_1d, 
        prediction_eos_1d: action.prediction_eos_1d, 
        prediction_bnb_1d: action.prediction_bnb_1d,

        prediction_doge_1d:  action.prediction_doge_1d, 
        prediction_ada_1d: action.prediction_ada_1d, 
        prediction_link_1d: action.prediction_link_1d,

        isFetching:false,
        isFetchingPrediction: false, // Default to fetching..
        isFetchingPrice: false, // Default to fetching..
        isFetchingPercentage: false, // Default to fetching..
            };

      case GET_DATA_PERCENTAGE_CHANGE:
      return {
        ...state,
        percentage_change: action.percentage_change, 
        isFetchingPercentage: false
      };


      case GET_CRYPTO_PRICE:
      return {
        ...state,
        value: action.crypto_price, 
        price_btc: action.price_btc,
        price_eth: action.price_eth,
        price_ltc: action.price_ltc,
        price_xrp: action.price_xrp,
        price_eos: action.price_eos,
        price_bnb: action.price_bnb,
        price_doge: action.price_doge,
        price_link: action.price_link,
        price_ada: action.price_ada,

        isFetchingPrice: false
      };


      case GET_CRYPTO_PREDICTION:
      return {
        ...state,
        prediction_btc: action.prediction_btc, 
        prediction_eth: action.prediction_eth,
        prediction_ltc: action.prediction_ltc,
        prediction_xrp: action.prediction_xrp,
        prediction_eos: action.prediction_eos,
        prediction_bnb: action.prediction_bnb,
        prediction_doge: action.prediction_doge,
        prediction_ada: action.prediction_ada,
        prediction_link: action.prediction_link,
        prediction_btc_1d: action.prediction_btc_1d, 
        prediction_eth_1d: action.prediction_eth_1d,
        prediction_ltc_1d: action.prediction_ltc_1d,
        prediction_xrp_1d: action.prediction_xrp_1d,
        prediction_eos_1d: action.prediction_eos_1d,
        prediction_bnb_1d: action.prediction_bnb_1d,
        prediction_doge_1d: action.prediction_doge_1d,
        prediction_ada_1d: action.prediction_ada_1d,
        prediction_link_1d: action.prediction_link_1d,
        isFetchingPrediction:false,
      };

    case GET_DATA_ERROR:
      console.log('Error: ', action.error);
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    default:
      return state;
  }
};

export default ProfileReducer